module.exports = __webpack_public_path__ + "img/map-download01.29450a70.jpg";